import { render } from "./PropertyDetails.vue?vue&type=template&id=0fdb9bf8&scoped=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"

import "./PropertyDetails.vue?vue&type=style&index=0&id=0fdb9bf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdb9bf8"]])

export default __exports__